function getKeys(dev) {
  if (!dev) {
    // Production
    return {
      apiKey: "AIzaSyB55oZmjL0lm3937dJ4XNDlAqe_qxw4nMA",
      authDomain: "photonow-app.firebaseapp.com",
      databaseURL: "https://photonow-app-default-rtdb.firebaseio.com",
      projectId: "photonow-app",
      storageBucket: "photonow-app.appspot.com",
      messagingSenderId: "411040390426",
      appId: "1:411040390426:web:2aff0e33f3692ee8b5e0a3",
    };
  } else {
    // Development
    return {
      apiKey: "AIzaSyC14xfZCwILN6-7XLRh0i3NSDUrL7sP8wk",
      authDomain: "cabine-teste.firebaseapp.com",
      databaseURL: "https://cabine-teste-default-rtdb.firebaseio.com",
      projectId: "cabine-teste",
      storageBucket: "cabine-teste.appspot.com",
      messagingSenderId: "247253049193",
      appId: "1:247253049193:web:dea312fb8950abf67a27f8",
    };
  }
}


const _env_dev =
document.location.hostname === "cabine-teste.web.app" ||
document.location.hostname === "localhost";

export const FIREBASE_CHAVE_SERVER = getKeys(_env_dev);

export const FUNCTIONS_URL = _env_dev
  ? "https://us-central1-cabine-teste.cloudfunctions.net/"
  : "https://us-central1-photonow-app.cloudfunctions.net/";

export const STORAGE_MOLDURA = _env_dev ? "gs://cabine-teste.appspot.com" : "gs://photonow-app-molduras";

// reCAPTCHA Enterprise site key registrada no Firebase App Check
// Prod: projeto photonow-app | Dev: projeto cabine-teste
export const RECAPTCHA_ENTERPRISE_KEY = _env_dev
  ? "6LcrOActAAAAANCf34x9M1cxNgdhxkKllJFpi2fY"
  : "6LcWXwctAAAAALR2ORrkT7priAG-6GqbTS0ehByC";

// Debug token do App Check — usado só em desenvolvimento
// Defina VUE_APP_APPCHECK_DEBUG_TOKEN no arquivo .env.local (não commitado)
export const APPCHECK_DEBUG_TOKEN = _env_dev
  ? (process.env.VUE_APP_APPCHECK_DEBUG_TOKEN || null)
  : null;
